
export default "/assets/bookshop.f362d776.svg"